import React, { Component } from "react";
import { Link } from "react-router-dom";
import "../css/Editions.css";

class EditionSingle extends Component {
  render() {
    return (
      <React.Fragment>
        <div className="col-md-6">
          <Link className="text-black" to={this.props.linkTo}>
            <div
              className="row g-0 border rounded overflow-hidden flex-md-row mb-4 shadow-sm h-md-250 position-relative">
              <div className="col p-4 d-flex flex-column position-static">
                <h3 className="mb-0">{this.props.editionName}</h3>
                <div className="mb-1 text-muted">{this.props.editionDate}</div>
                <p className="card-text mb-auto">{this.props.editionDescription}</p>
                <span href="A World of Wonders" className="stretched-link" id="minds">Continue
                  reading</span>
              </div>
              <div className="col-auto d-none d-lg-block">
                <img className="bd-placeholder-img" width="200" height="250"
                  src={this.props.editionCover} alt="" />
              </div>
            </div>
          </Link>
        </div>
      </React.Fragment >
    );
  }
}

export { EditionSingle };